import React from 'react';
import { node, string } from 'prop-types';

import styles from './Feature.scss';

export default function Feature({ icon, title, description }) {
  return (
    <div className={styles.root}>
      <div className={styles.desktopStyle}>
        <div className={styles.content}>
          <div className={styles.text}>
            <div className={styles.icon}>{icon}</div>
            <h4>{title}</h4>
          </div>
        </div>
        <div className={styles.banner} />
        <div className={styles.hiddenContent}>
          <h4>{title}</h4>
          <p>{description}</p>
        </div>
      </div>
      <div className={styles.mobileStyle}>
        <div className={styles.content}>
          <div className={styles.icon}>{icon}</div>
          <h4>{title}</h4>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
}

Feature.propTypes = {
  description: string.isRequired,
  icon: node.isRequired,
  title: string.isRequired,
};



// WEBPACK FOOTER //
// ./app/containers/Mission/components/Feature/Feature.jsx